<template>
	<div class="page container">
		<div class="page__info">
			<div class="page__info--title">
				Users
			</div>
		</div>

		<table-view
			:table="getTable"
			:pagination="pagination"
			:totalItems="totalItems"
			@search="onSearch"
			@paginate="onPaginate"
			class="page__table"
		/>

	</div>
</template>

<script>
	import TableView     from '@/components/ui/views/tableView/TableView';
	import api           from '@/services/api';
	import dayjs         from 'dayjs';
	import relativeTime  from 'dayjs/plugin/relativeTime';

	dayjs.extend(relativeTime);

	export default {
		layout: 'v2default',
		metaInfo: {
			title: 'Users'
		},
		components: {
			TableView
		},
		data: () => ({
			users: [],
			searchString: '',
			pagination: {
				perPage: 20,
				currentPage: 1,
				totalPages: 0
			},
			totalItems: 0
		}),
		computed: {
			getTable () {
				return {
					headings: [
						'Name',
						'Email',
						'Teacher',
						'Admin',
						'Email Verified'
					],
					rows: this.users.map((user) => {
						return {
							route: `/admin/users/${user.id}`,
							columns: [
								this.getNameString(user) || 'Not set',
								this.getEmailString(user) || 'Not set',
								user.isTeacher ? 'Yes' : '--',
								user.isAdmin ? 'Yes' : '--',
								user.verified ? 'Yes' : '--'
							]
						};
					})
				};
			},
			getBreadcrumbs () {
				return [
					{
						path: '/admin',
						text: 'Admin'
					},
					{
						path: '/admin/users',
						text: 'Users'
					}
				].filter(Boolean);
			}
		},
		created: function () {
			this.setUsers();
		},
		methods: {
			onSearch (value) {
				this.searchString = value;
				this.setUsers();
			},
			onPaginate (value) {
				this.pagination.currentPage = value;
				this.setUsers();
			},
			getNameString (user) {
				if (!user) {
					return false;
				}

				const fullName = [
					user?.firstName,
					user?.lastName
				].filter(Boolean);

				if (fullName.length === 0) {
					return 'Not set';
				}
				return fullName.join(' ');
			},
			getEmailString (user) {
				if (!user || !user.email) {
					return false;
				}
				return user.email;
			},
			async setUsers () {
				const response = await api.admin.getAllUsers({
					include: 'metadata',
					searchString: this.searchString,
					per: this.pagination.perPage,
					page: this.pagination.currentPage
				});
				if (!response) {
					this.$store.commit('ui/showError');
					return false;
				}
				this.totalItems = response.meta.totalItems;
				this.pagination.totalPages = response.meta.numPages;
				this.pagination.currentPage = response.meta.page;
				this.users = response.results;
				this.$store.commit('ui/setBreadcrumbs', {
					breadcrumbs: this.getBreadcrumbs
				});
				this.$store.commit('ui/setLoadingIsHidden');
			}
		}
	};
</script>

<style lang="scss" scoped>
.page__info {
  margin-bottom: 24px;
}
.page__table ::v-deep [data-element="col"] {
	@include mq('lg') {
		margin-inline: 0 rem(12);
	}
	word-break:break-all
}

</style>
